"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddressPicker = void 0;
var _objectSpread2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));
var _slicedToArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _objectWithoutProperties2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _InputWithIcon = require("../../../elements/input-with-icon/InputWithIcon");
var _react = _interopRequireWildcard(require("react"));
var _reactPlacesAutocomplete = _interopRequireWildcard(require("react-places-autocomplete"));
var _Option = require("../../../elements/option/Option");
var _popover = require("@reach/popover");
var _Paper = require("../../../elements/paper/Paper");
var _countries = require("../../../constants/countries/countries");
var _reactResizeDetector = require("react-resize-detector");
var _useHandleClickOutside = require("../../../hooks/useHandleClickOutside/useHandleClickOutside");
var _plusCircled = require("../../../assets/icons/plus-circled.svg");
var _addressPickerModule = _interopRequireDefault(require("./address-picker.module.scss"));
var _useTranslation2 = require("../../../hooks/useTranslation/useTranslation");
var _noop = require("../../../utils/noop");
var _excluded = ["key"];
var isSuggestionStatusHandled = function isSuggestionStatusHandled(status) {
  return status === 'ZERO_RESULTS';
};
var React18PlacesAutocomplete = _reactPlacesAutocomplete.default;
var AddressOptions = function AddressOptions(_ref) {
  var suggestions = _ref.suggestions,
    getSuggestionItemProps = _ref.getSuggestionItemProps,
    setHasSuggestions = _ref.setHasSuggestions,
    handleManualAddressClick = _ref.handleManualAddressClick,
    popoverRef = _ref.popoverRef,
    inputRef = _ref.inputRef,
    popoverClassName = _ref.popoverClassName,
    setMainText = _ref.setMainText,
    id = _ref.id,
    suggestionStatus = _ref.suggestionStatus;
  var _useTranslation = (0, _useTranslation2.useTranslation)(),
    t = _useTranslation.t;
  var _useResizeDetector = (0, _reactResizeDetector.useResizeDetector)({
      targetRef: inputRef
    }),
    width = _useResizeDetector.width;
  (0, _react.useEffect)(function () {
    if (suggestions && suggestions.length > 0) {
      setHasSuggestions(true);
    } else {
      setHasSuggestions(false);
    }
  }, [suggestions, setHasSuggestions]);
  var renderPopover = function renderPopover(suggestions) {
    return /*#__PURE__*/_react.default.createElement(_popover.Popover, {
      ref: popoverRef
      // 82px here is a padding + border for suffix and preffix icon which we need to add to extend width
      ,
      style: {
        width: width + 82
      },
      "data-testid": 'address-picker-popover',
      targetRef: inputRef,
      className: popoverClassName
    }, /*#__PURE__*/_react.default.createElement(_Paper.Paper, {
      "data-testid": "".concat(id, ".container")
    }, suggestions.map(function (suggestion) {
      var _getSuggestionItemPro = getSuggestionItemProps(suggestion),
        key = _getSuggestionItemPro.key,
        rest = (0, _objectWithoutProperties2.default)(_getSuggestionItemPro, _excluded);
      return /*#__PURE__*/_react.default.createElement(_Option.Option, Object.assign({
        key: suggestion.placeId
      }, rest, {
        onClick: function onClick(event) {
          setMainText(suggestion.formattedSuggestion.mainText);
          rest.onClick(event);
        }
      }), /*#__PURE__*/_react.default.createElement("span", null, suggestion.description));
    }), /*#__PURE__*/_react.default.createElement("div", {
      onClick: handleManualAddressClick,
      className: _addressPickerModule.default['address-picker__manual-address']
    }, /*#__PURE__*/_react.default.createElement(_plusCircled.ReactComponent, {
      className: _addressPickerModule.default['address-picker__add-icon']
    }), t('addressPicker.enterAddressManually'))));
  };
  if (suggestionStatus === 'ZERO_RESULTS') {
    return renderPopover([]);
  }
  return suggestions && suggestions.length > 0 ? renderPopover(suggestions) : null;
};
var AddressPicker = function AddressPicker(_ref2) {
  var id = _ref2.id,
    name = _ref2.name,
    placeholder = _ref2.placeholder,
    onSelect = _ref2.onSelect,
    onClear = _ref2.onClear,
    className = _ref2.className,
    popoverClassName = _ref2.popoverClassName,
    addressRestrictions = _ref2.addressRestrictions,
    _ref2$isManualAddress = _ref2.isManualAddressSelected,
    isManualAddressSelected = _ref2$isManualAddress === void 0 ? _noop.noop : _ref2$isManualAddress,
    maxLength = _ref2.maxLength,
    _ref2$onManualAddress = _ref2.onManualAddressSelect,
    onManualAddressSelect = _ref2$onManualAddress === void 0 ? _noop.noop : _ref2$onManualAddress;
  var popoverRef = (0, _react.useRef)(null);
  var inputRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(''),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    currentValue = _useState2[0],
    setCurrentValue = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    selectedAddress = _useState4[0],
    setSelectedAddress = _useState4[1];
  var mainTextRef = (0, _react.useRef)('');
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    isOpen = _useState6[0],
    setIsOpen = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    hasSuggestions = _useState8[0],
    setHasSuggestions = _useState8[1];
  var _useState9 = (0, _react.useState)(undefined),
    _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
    suggestionStatus = _useState10[0],
    setSuggestionStatus = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
    isManualAddress = _useState12[0],
    setIsManualAddress = _useState12[1];
  var onClickOutside = function onClickOutside() {
    if (hasSuggestions || suggestionStatus === 'ZERO_RESULTS') {
      setIsManualAddress(true);
      isManualAddressSelected(true);
      onManualAddressSelect(currentValue);
    }
    setIsOpen(function (isOpen) {
      return !isOpen;
    });
  };
  (0, _useHandleClickOutside.useHandleClickOutside)(isOpen, onClickOutside, [popoverRef, inputRef]);
  var handleShowOptions = (0, _react.useCallback)(function () {
    if (isManualAddress) {
      setIsOpen(false);
    } else {
      setIsOpen(true);
    }
  }, [isManualAddress]);
  var mapAddress = function mapAddress(result) {
    var address = {};
    var route = '';
    var streetNumber = '';
    var postalCode = '';
    var postalCodeSuffix = '';
    var country = result.address_components.find(function (component) {
      return component.types.includes('country');
    });
    result.address_components.forEach(function (component) {
      var componentType = component.types[0];
      switch (componentType) {
        case 'street_number':
          {
            streetNumber = component.long_name;
            address.streetNumber = component.long_name;
            break;
          }
        case 'route':
          {
            route = component.long_name;
            break;
          }
        case 'postal_code':
          {
            postalCode = component.long_name;
            break;
          }
        case 'postal_code_suffix':
          {
            postalCodeSuffix = "-".concat(component.long_name);
            break;
          }
        case 'administrative_area_level_1':
          {
            address.state = country && country.short_name === 'US' ? component.short_name : undefined;
            break;
          }
        case 'locality':
        case 'postal_town':
          {
            address.city = component.long_name;
            break;
          }
        case 'country':
          {
            var _country = _countries.COUNTRIES.find(function (c) {
              return c.code === component.short_name;
            });
            address.country = _country ? _country.name : undefined;
            address.countryCode = component.short_name;
            break;
          }
      }
    });
    address.address1 = "".concat(route, " ").concat(streetNumber) !== ' ' ? "".concat(route, " ").concat(streetNumber) : mainTextRef.current;
    address.postalCode = "".concat(postalCode).concat(postalCodeSuffix);
    return address;
  };
  var handleSelect = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(value, placeId) {
      var result, address;
      return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _reactPlacesAutocomplete.geocodeByPlaceId)(placeId);
            case 2:
              result = _context.sent;
              address = mapAddress(result[0]);
              setSelectedAddress(address.address1);
              setIsManualAddress(false);
              isManualAddressSelected(false);
              onSelect(address);
            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function handleSelect(_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  var handleManualAddressClick = function handleManualAddressClick() {
    setIsManualAddress(true);
    isManualAddressSelected(true);
    inputRef.current.focus();
    setIsOpen(false);
    onManualAddressSelect(currentValue);
  };
  var searchOptions = {
    componentRestrictions: addressRestrictions ? (0, _objectSpread2.default)({}, addressRestrictions) : undefined
  };
  var handleChange = function handleChange(value) {
    setSelectedAddress('');
    setCurrentValue(value);
  };
  var onManualAddressChange = function onManualAddressChange(e) {
    onManualAddressSelect(e.currentTarget.value);
  };
  var handleError = function handleError(status) {
    if (isSuggestionStatusHandled(status)) {
      setSuggestionStatus(status);
    }
  };
  return /*#__PURE__*/_react.default.createElement(React18PlacesAutocomplete, {
    value: currentValue,
    onChange: handleChange,
    onSelect: handleSelect,
    searchOptions: searchOptions,
    debounce: 1000,
    onError: handleError
  }, function (_ref4) {
    var getSuggestionItemProps = _ref4.getSuggestionItemProps,
      getInputProps = _ref4.getInputProps,
      suggestions = _ref4.suggestions,
      loading = _ref4.loading;
    var _getInputProps = getInputProps(),
      _onChange = _getInputProps.onChange;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_InputWithIcon.SearchInput, {
      onFocus: handleShowOptions,
      onClick: handleShowOptions,
      className: className,
      ref: inputRef,
      id: id,
      "data-testid": id,
      name: name,
      placeholder: placeholder,
      value: selectedAddress ? selectedAddress : currentValue,
      autoComplete: "off",
      onChange: function onChange(event) {
        if (!event.currentTarget.value) {
          setIsManualAddress(false);
          isManualAddressSelected(false);
          onClear();
          setSuggestionStatus(undefined);
        }
        _onChange(event);
        if (currentValue === '') {
          handleShowOptions();
        }
        if (isManualAddress) {
          onManualAddressChange(event);
        }
      },
      isLoading: !isManualAddress ? loading : false,
      maxLength: maxLength
    }), isOpen && /*#__PURE__*/_react.default.createElement(AddressOptions, {
      suggestions: suggestions,
      getSuggestionItemProps: getSuggestionItemProps,
      setHasSuggestions: setHasSuggestions,
      handleManualAddressClick: handleManualAddressClick,
      popoverRef: popoverRef,
      inputRef: inputRef,
      popoverClassName: popoverClassName,
      setMainText: function setMainText(mainText) {
        mainTextRef.current = mainText;
      },
      id: id,
      suggestionStatus: suggestionStatus
    }));
  });
};
exports.AddressPicker = AddressPicker;